import { LookupOptionDto } from './lookup-option.dto';

export class LookupOption {
    readonly label: string;
    readonly value: string;

    constructor(dto: LookupOptionDto) {
        this.label = dto.name ?? '';
        this.value = String(dto.id);
    }
}
